import { useEffect } from 'react';

const useTitle = (title: string) => {
  useEffect(() => {
    document.title = `UTP + Portal | ${title}`;
    return () => {
      document.title = 'UTP+ Portal | Universidad Tecnológica del Perú';
    };
  }, []);
};

export default useTitle;
